export const PRIZE_TRESHOLD = 6;
export const TOTAL_BADGES = 6;
